import React, { useState, useEffect } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { ListSubheader } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./quotaCopySlice";

const MultiSelectCountry = (props) => {
   const dispatch = useDispatch();
   const state = useSelector((store) => store.quotaCopy);
   const { countries, selectedCountries, clearDataValues } = state;
   let products = countries?.map((item) => item.countryName);
   products = products.filter((item) => item !== "All");
   const [productName, setproductName] = useState([]);
   const [displayItem, setDisplayItem] = React.useState(countries.length - 1);
   const [searchText, setSearchText] = React.useState("");
   const [namesData, setNamesData] = React.useState([]);
   const textInput = React.useRef(null);
   const [selectedOptions, setSelectedOptions] = useState([]);
   const [selectAll, setSelectAll] = useState(false);

   const handleChange = (event) => {
      const value = event.target.value;
      // const arrayValue = typeof value === "string" ? value.split(",") : value;
      setproductName(value);
      dispatch(setState("selectedCountries", value));

      let itemcount = value.length - 1;
      setDisplayItem(itemcount);
   };

   useEffect(() => {
      console.log(productName);
   }, [productName]);

   useEffect(() => {
      // Clear search text value
      setNamesData(products);
   }, [countries]);

   const handleDelete = (e, value) => {
      e.preventDefault();
      //setproductName(productName.filter((name) => name !== value));
      dispatch(setState("selectedCountries", []));
      setproductName([]);
      setSelectAll(false);
   };

   const handleInputChange = (value) => {
      setSearchText(value);
   };

   const handleSelectAll = (event) => {
      setSelectAll(!selectAll);
   };

   useEffect(() => {
      let itemcount = selectedOptions.length - 1;
      setDisplayItem(itemcount);
   }, [selectedOptions]);

   useEffect(() => {
      if (selectAll) {
         let itemcount = namesData.length - 1;
         setDisplayItem(itemcount);
         setproductName(products);
         dispatch(setState("selectedCountries", products));
      } else {
         setproductName([]);
         dispatch(setState("selectedCountries", []));
      }
   }, [selectAll]);

   useEffect(() => {
      //use a debounce to delay the search input key entry
      const delayDebounceFn = setTimeout(() => {
         if (searchText) {
            //filter options state using search text provided
            setNamesData((prevVal) => {
               let val = namesData.filter((name) =>
                  name.toLowerCase().includes(searchText.toLowerCase())
               );

               return val;
            });
         } else {
            setSearchText();
            setNamesData(products);
         }

         //set focus on search text input field on load. setTimeOut is added as textInput is not immediately available
         setTimeout(() => {
            if (textInput.current) textInput.current.focus();
         }, 100);
      }, 500);

      return () => clearTimeout(delayDebounceFn);
   }, [searchText]);

   const getProductIdsFromNames = (productNames) => {
      const productIds = productNames.map((name) => {
         const product = countries.find(
            (option) => option.countryName === name
         );
         return product ? product.countryID : null;
      });
      return productIds.filter((id) => id !== null);
   };

   useEffect(() => {
      if (productName.length > 0) {
         dispatch(
            setState(
               "selectedDataProductIds",
               getProductIdsFromNames(productName)
            )
         );
         dispatch(setState("clearDataValues", false));
      } else {
         dispatch(setState("selectedDataProductIds", []));
      }
   }, [productName]);

   useEffect(() => {
      if (clearDataValues) {
         setproductName([]);
         setSelectAll(false);
      }
   }, [clearDataValues]);

   return (
      <div>
         <FormControl>
            <InputLabel>Country</InputLabel>
            <Select
               labelId="demo-multiple-checkbox-label"
               id="demo-multiple-checkbox"
               multiple
               fullWidth
               // sx={{width:300}}
               value={productName}
               onChange={(event) => handleChange(event)}
               size="small"
               input={<OutlinedInput label="MultiSelect" />}
               renderValue=
               // {(selected) => (
               //    <Box
               //       sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
               //       MenuProps
               //    >
               //       {selected.map((value, index) => (
               //          <div>
               //             {index < 1 ? (
               //                <Chip
               //                   key={index}
               //                   label={value}
               //                   clickable
               //                   color="primary"
               //                   variant="contained"
               //                   deleteIcon={
               //                      <CancelIcon
               //                         onMouseDown={(e) => {
               //                            e.stopPropagation();
               //                            e.preventDefault();
               //                         }}
               //                      />
               //                   }
               //                   onDelete={(e) => handleDelete(e, value)}
               //                />
               //             ) : (
               //                <div>
               //                   {index < 2 ? <div>+ {displayItem}</div> : null}
               //                </div>
               //             )}
               //          </div>
               //       ))}
               //    </Box>
               // )}
               {(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }} MenuProps>
                        <div>
                          {productName.length === 1 &&(
                          <span>{productName[0]?.substring(0, 12)}</span>
                          )}
                          {productName.length > 1 && (
                            <span>{productName[0]?.substring(0, 12)}  + <b>{displayItem}</b></span>
                          )}
                          <span>
                            <CancelIcon
                              sx={{
                                paddingLeft: "25px",
                                top: "20%",
                                position: "absolute",
                              }}
                              onMouseDown={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                              }}
                              onClick={(e) => handleDelete(e)}
                            />
                          </span>
                        </div>
                  </Box>
                )}               
            >
               <MenuItem
                  key={"All"}
                  value={"All"}
                  onClick={(event) => handleSelectAll(event)}
               >
                  <Checkbox checked={selectAll} />
                  <ListItemText primary="Select All" />
               </MenuItem>
               <ListSubheader>
                  <TextField
                     size="small"
                     inputRef={textInput}
                     placeholder=""
                     //fullWidth
                     value={searchText}
                     InputProps={{
                        startAdornment: (
                           <InputAdornment position="start">
                              <SearchIcon />
                           </InputAdornment>
                        ),
                        endAdornment: (
                           /*close icon to clear the search text*/
                           <InputAdornment position="end">
                              <IconButton onClick={() => setSearchText("")}>
                                 <CloseIcon />
                              </IconButton>
                           </InputAdornment>
                        ),
                     }}
                     onChange={(e) => handleInputChange(e.target.value)}
                     onKeyDown={(e) => {
                        if (e.key !== "Escape") {
                           // Prevents autoselecting item while typing (default Select behaviour)
                           e.stopPropagation();
                        }
                     }}
                  />
               </ListSubheader>
               {namesData?.map((name, index) => (
                  <MenuItem key={index + name} value={name}>
                     {selectAll ? (
                        <Checkbox
                           checked={productName.some((o) => o === name)}
                        />
                     ) : (
                        <Checkbox checked={productName.indexOf(name) > -1} />
                     )}
                     <ListItemText primary={name} />
                  </MenuItem>
               ))}
            </Select>
         </FormControl>
      </div>
   );
};

export default MultiSelectCountry;
